<template>
    <!-- TODO - EPIC-1000 EPIC : Soap migration -->
    <div style="position: relative;">
        <!------- View ------->
        <b-navbar-nav v-if="profile.mode == 'VIEW'">
            <!-- Need to confirm with i_am_editor in ci EPIC-1000-->
            <b-nav-item
                v-if="_hasAccess('patient.record.update') && !isLocked"
                @click="editSoap()"
            >
                <i class="cus-page-white-edit"></i>Edit Profile
            </b-nav-item>

            <b-nav-item-dropdown
                v-if="
                    _hasAccess('patient.record.soap.email') ||
                    _hasAccess('patient.record.soap.print')
                "
            >
                <template slot="button-content">
                    <spinner v-if="isExporting" />
                    <i v-else class="cus-page-attach"></i>
                    Export
                </template>
                <b-dropdown-item
                    v-if="_hasAccess('patient.record.soap.email')"
                    @click="exportSoap('email')"
                >
                    <i class="cus-email"></i>
                    Email Note
                </b-dropdown-item>
                <b-dropdown-item
                    v-if="_hasAccess('patient.record.soap.print')"
                    @click="exportSoap('print')"
                >
                    <i class="cus-printer"></i>
                    Print Note
                </b-dropdown-item>
            </b-nav-item-dropdown>

            <b-nav-item
                v-if="_hasAccess('patient.record.create')"
                @click="duplicateSoap()"
            >
                <i class="cus-page-copy"></i>Duplicate
            </b-nav-item>

            <DropdownAppointmentStatus
                :isInvoice="false"
                @reload-page="reloadPage"
            ></DropdownAppointmentStatus>

            <b-nav-item
                @click="confirmLock()"
                v-if="_hasAccess('patient.record.soap.lock') && !isLocked"
            >
                <i class="cus-lock"></i>Lock Note
            </b-nav-item>

            <!-- CHECK IF NOT SENT -->
            <b-nav-item
                @click="confirmDelete()"
                v-if="_hasAccess('patient.record.soap.delete') && !isLocked"
            >
                <i class="cus-delete"></i>Delete Note
            </b-nav-item>
            <!------- Edit ------->
        </b-navbar-nav>
        <b-navbar-nav v-if="profile.mode == 'EDIT' && profile.isSaving">
            <b-nav-item>
                Saving...
            </b-nav-item>
        </b-navbar-nav>
        <b-navbar-nav
            v-if="profile.mode == 'EDIT' && profile.isSaving === false"
        >
            <b-nav-item @click="saveEdit">
                <i class="cus-disk"></i>Save + Done
            </b-nav-item>
            <b-nav-item @click="cancelEdit">
                <i class="cus-cancel"></i>Cancel
            </b-nav-item>
        </b-navbar-nav>
        <template v-if="soapDetails">
            <modal-delete ref="modalDeleteNote" />
            <modal-lock ref="modalLockNote" @reload-page="reloadPage" />
            <modal-duplicate ref="modalDuplicateSoap" />
            <modal-export-soap
                ref="modalExportSoap"
                :soapId="soapDetails.id"
                :patientDetails="soapDetails.patient"
                :providerId="
                    (soapDetails.prescribed_by &&
                        soapDetails.prescribed_by.id) ||
                    (soapDetails.default_provider &&
                        soapDetails.default_provider.id)
                "
            />
        </template>
    </div>
</template>
<script>
/**
 * @name Soap Navbar
 * @description soap navbar
 * @see apps/application/views/staff/patient/soap/navbar.php
 */

export default {
    components: {
        Spinner: () => import("@/components/elements/spinner"),
        ModalDelete: () => import("@/components/soap/soap-delete"),
        ModalLock: () => import("@/components/soap/soap-lock"),
        ModalExportSoap: () => import("@/components/soap/modal-export-soap"),
        DropdownAppointmentStatus: () =>
            import("@/components/appointments/appointment-status-dropdown"),
        ModalDuplicate: () =>
            import("@/components/medical-notes/note-duplicate-modal")
    },
    data() {
        return {
            isExporting: false
        };
    },
    props: {
        profile: {
            type: Object,
            required: true
        }
    },
    watch: {},
    computed: {
        soapDetails() {
            return this.$store.getters["soap/soapDetails"];
        },
        isLocked() {
            return this.$store.getters["soap/isLocked"];
        }
    },
    methods: {
        editSoap() {
            this.$store.commit("soap/setEditMode", true);
            this.$emit("changeEditMode", true);
        },
        cancelEdit() {
            this.$store.dispatch("soap/cancelEdit");
            this.$emit("changeEditMode", false);
        },
        saveEdit() {
            this.$emit("saving-soap-details");
        },
        reloadPage() {
            this.$emit("reload-page");
        },
        confirmDelete() {
            this.$refs.modalDeleteNote.open(this.soapDetails);
        },
        confirmLock() {
            this.$refs.modalLockNote.open();
        },
        exportSoap(action) {
            this.$refs.modalExportSoap.open({ action });
        },
        duplicateSoap() {
            if (this.soapDetails) {
                this.$refs.modalDuplicateSoap.open(this.soapDetails);
            }
        }
    }
};
</script>
